import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3bc4dd62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3bc4dd62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4dd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc4dd62')) {
      api.createRecord('3bc4dd62', component.options)
    } else {
      api.reload('3bc4dd62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3bc4dd62&scoped=true", function () {
      api.rerender('3bc4dd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/distribute/index.vue"
export default component.exports